/**
 * สถานะของ order
 */
export enum OrderPrivilegeStatus {
  PENDING = 'PENDING', // รอการชำระเงิน
  PAYMENT_PENDING = 'PAYMENT_PENDING', // รอการยืนยันการชำระเงิน
  PAID = 'PAID', // ชำระเงินแล้ว
  PROCESSING = 'PROCESSING', // กำลังประมวลผล
  SHIPPED = 'SHIPPED', // จัดส่งแล้ว
  DELIVERED = 'DELIVERED', // ส่งถึงแล้ว
  CANCELLED = 'CANCELLED', // ยกเลิกแล้ว
  REFUNDED = 'REFUNDED', // คืนเงินแล้ว
  EXPIRED = 'EXPIRED', // หมดอายุ
}

/**
 * สถานะการจัดส่ง
 */
export enum ShippingStatus {
  SELF_PICKUP = 'SELF_PICKUP', // รับรางวัลเอง
  PENDING = 'PENDING', // รอการจัดส่ง
  PROCESSING = 'PROCESSING', // กำลังจัดส่ง
  SHIPPED = 'SHIPPED', // จัดส่งแล้ว
  DELIVERED = 'DELIVERED', // ส่งถึงแล้ว
  FAILED = 'FAILED', // จัดส่งไม่สำเร็จ
  RETURNED = 'RETURNED', // ส่งคืน
}

/**
 * ประเภทการชำระเงิน
 */
export enum PaymentType {
  CASH = 'CASH', // เงินสด
  TOKEN = 'TOKEN', // Token
  MIXED = 'MIXED', // ผสมผสาน (เงินสด + Token)
  FREE = 'FREE', // ฟรี
}

/**
 * สถานะการชำระเงิน
 */
export enum PaymentStatus {
  PENDING = 'PENDING', // รอการชำระเงิน
  PROCESSING = 'PROCESSING', // กำลังประมวลผล
  SUCCESS = 'SUCCESS', // สำเร็จ
  FAILED = 'FAILED', // ล้มเหลว
  CANCELLED = 'CANCELLED', // ยกเลิก
  REFUNDED = 'REFUNDED', // คืนเงิน
}

/**
 * ข้อมูลการชำระเงินด้วยเงินสด
 */
export interface CashPayment {
  /** สกุลเงิน */
  currency: string

  /** จำนวนเงินที่จ่าย (บาท) */
  amount: number

  /** รหัส Transaction ที่เกี่ยวข้อง */
  transactionId?: string

  /** วันที่ชำระเงิน */
  paidAt?: Date

  isPaid: boolean

  // ===== ข้อมูล Chillpay =====

  /** รหัสการชำระเงินจาก Chillpay */
  chillpayTransactionId?: string

  /** รหัสการชำระเงินจากระบบ */
  paymentReference?: string

  /** URL สำหรับชำระเงิน */
  paymentUrl?: string

  /** ข้อมูลเพิ่มเติมจาก Chillpay */
  chillpayMetadata?: {
    gateway: string
    method: string
    cardType?: string
    bankCode?: string
    installment?: number
    [key: string]: unknown
  }
}

/**
 * ข้อมูลการชำระเงินด้วย Token แต่ละชนิด
 */
export interface TokenPayment {
  /** รหัสของ Token */
  tokenId: string

  /** ชื่อของ Token */
  tokenName: string

  /** จำนวน Token ที่ใช้ */
  amount: number

  /** รหัส Transaction ที่เกี่ยวข้อง */
  transactionId?: string

  /** วันที่ชำระเงิน */
  paidAt?: Date

  isPaid: boolean
}

/**
 * Interface สำหรับเก็บข้อมูลการสั่งซื้อ Privilege
 */
export interface OrderPrivilege {
  /** รหัสของ Order Privilege */
  id: string

  /** เลขที่คำสั่งซื้อ (unique) */
  orderNumber: string

  /** รหัสของ user ที่สั่งซื้อ */
  userId: string

  /** รหัสของ privilege ที่สั่งซื้อ */
  privilegeId: string

  /** สถานะของ order */
  status: OrderPrivilegeStatus

  /** รหัสที่อยู่จัดส่ง */
  userAddressId: string

  /** สถานะการจัดส่ง */
  shippingStatus: ShippingStatus

  /** หมายเหตุการจัดส่ง */
  shippingNote?: string

  /** เลขพัสดุ */
  trackingNumber?: string

  /** วันที่จัดส่ง */
  shippedAt?: Date

  /** วันที่ส่งถึง */
  deliveredAt?: Date

  /** หมายเหตุเพิ่มเติม */
  note?: string

  /** วันที่สร้าง */
  createdAt: Date

  /** วันที่อัปเดตล่าสุด */
  updatedAt: Date

  // ===== ข้อมูลการชำระเงิน =====
  /** ประเภทการชำระเงิน */
  paymentType: PaymentType

  /** สถานะการชำระเงิน */
  paymentStatus: PaymentStatus

  /** ข้อมูลการชำระเงินด้วยเงินสด */
  cashPayment?: CashPayment

  /** รายการ Token ที่ใช้ในการชำระเงิน */
  tokenPayments: TokenPayment[]

  // ===== ข้อมูลการตรวจสอบ =====

  /** วันที่หมดอายุการชำระเงิน */
  paymentExpiredAt: Date

  /** วันที่หมดอายุของ privilege */
  privilegeExpiredAt: Date

  /** วันที่เริ่มใช้งาน privilege */
  privilegeStartAt?: Date
}
